import {createElement, PropTypes} from 'rlink-react';
import {FormattedMessage} from 'react-intl';
import NavLink from 'rlink-router/NavLink.jsx';

export default function MoreInfoButton ({css, identifier, showMoreInfoButton, moreInfoButtonLabel, onClick}) {
  if (showMoreInfoButton) {
    let label = (moreInfoButtonLabel)
      ? moreInfoButtonLabel
      : <FormattedMessage
        id="ui.label.button.MORE_INFO"
        defaultMessage="more info"
        description="More info button that appears on a shop item." />;
    return (
      <NavLink href={onClick()}
        id={`info-${identifier}`}
        className={`${css.btn} ${css['btn-small']} ${css['button-foreground']}`}>
        {label}
      </NavLink>
    );
  }
  return null;
}

MoreInfoButton.propTypes = {
  css: PropTypes.object,
  identifier: PropTypes.string,
  showMoreInfoButton: PropTypes.bool,
  moreInfoButtonLabel: PropTypes.string,
  onClick: PropTypes.func,
};


MoreInfoButton.defaultProps = {
  showMoreInfoButton: true,
};



// WEBPACK FOOTER //
// ./lib/rlink-shop/components/MoreInfoButton.jsx